(function () {
  'use strict';

  /*
   * ============================================================
   * SELLY WAS / NOW PRICING
   * ============================================================
   *
   * Supports:
   *
   * 1. Percentage offers
   *    Selly label: "10% Off!"
   *
   *    Result:
   *    Was €169.95   €152.96
   *
   * 2. Fixed price offers
   *    Selly label: "NOW €399"
   *
   *    Result:
   *    Was €499.00   €399.00
   *
   * The original product price is stored ONCE so that the
   * script can never calculate a discount from an already
   * discounted price.
   */


  /*
   * ============================================================
   * HELPER: FORMAT EURO PRICE
   * ============================================================
   */

  function formatPrice(number) {

    return '€' + Number(number).toFixed(2);

  }


  /*
   * ============================================================
   * HELPER: GET NUMERIC PRICE
   * ============================================================
   */

  function getNumericPrice(text) {

    if (!text) return null;

    var cleaned = text
      .replace(/[^\d,.-]/g, '')
      .replace(',', '.');

    var number = parseFloat(cleaned);

    return isNaN(number) ? null : number;

  }


  /*
   * ============================================================
   * HELPER: FIND SELLY LABEL
   * ============================================================
   */

  function getSellyLabel(card) {

    return card.querySelector(
      '.tdf_label .tdf_ribbon_span'
    );

  }


  /*
   * ============================================================
   * HELPER: FIND PRODUCT PRICE
   * ============================================================
   */

  function getCollectionPriceElements(priceArea) {

    var currentPrice =
      priceArea.querySelector('.new-price');

    if (!currentPrice) {

      var spans =
        priceArea.querySelectorAll(
          'span:not(.old-price)'
        );

      for (var i = 0; i < spans.length; i++) {

        if (
          !spans[i].closest('.old-price') &&
          spans[i].textContent.trim()
        ) {

          currentPrice = spans[i];
          break;

        }

      }

    }

    var oldPrice =
      priceArea.querySelector('.old-price');

    return {
      currentPrice: currentPrice,
      oldPrice: oldPrice
    };

  }


  /*
   * ============================================================
   * COLLECTION PAGE
   * ============================================================
   */

  function updateCollectionPrices() {

    document
      .querySelectorAll('.tt-product')
      .forEach(function (card) {

        var priceArea =
          card.querySelector('.tt-price');

        if (!priceArea) return;


        var elements =
          getCollectionPriceElements(priceArea);

        var currentPrice =
          elements.currentPrice;

        var oldPrice =
          elements.oldPrice;

        if (!currentPrice || !oldPrice) return;


        /*
         * --------------------------------------------------------
         * CAPTURE ORIGINAL PRICE ONCE
         * --------------------------------------------------------
         *
         * IMPORTANT:
         * This is stored on the PRODUCT CARD rather than the
         * price element.
         *
         * Therefore our own discounted price can never become
         * the new "original" price.
         */

        if (!card.dataset.sellyOriginalPrice) {

          var originalText =
            currentPrice.textContent.trim();

          var originalNumber =
            getNumericPrice(originalText);

          if (originalNumber === null) return;

          card.dataset.sellyOriginalPrice =
            originalNumber.toString();

        }


        var originalNumber =
          parseFloat(
            card.dataset.sellyOriginalPrice
          );

        if (isNaN(originalNumber)) return;


        /*
         * --------------------------------------------------------
         * FIND SELLY LABEL
         * --------------------------------------------------------
         */

        var label =
          getSellyLabel(card);


        /*
         * --------------------------------------------------------
         * NO SELLY PROMOTION
         * --------------------------------------------------------
         */

        if (!label) {

          /*
           * Only restore if this card was previously displaying
           * a promotion.
           */

          if (
            card.dataset.sellyWasNowActive === 'true'
          ) {

            currentPrice.textContent =
              formatPrice(originalNumber);

            oldPrice.innerHTML = '';

            oldPrice.className =
              card.dataset.sellyOriginalOldClass ||
              'old-price hide';


            /*
             * Restore original styling.
             */

            if (
              card.dataset.sellyOriginalPriceStyle !==
              undefined
            ) {

              currentPrice.setAttribute(
                'style',
                card.dataset.sellyOriginalPriceStyle
              );

            }


            if (
              card.dataset.sellyOriginalOldStyle !==
              undefined
            ) {

              oldPrice.setAttribute(
                'style',
                card.dataset.sellyOriginalOldStyle
              );

            }


            if (
              card.dataset.sellyOriginalContainerStyle !==
              undefined
            ) {

              priceArea.setAttribute(
                'style',
                card.dataset.sellyOriginalContainerStyle
              );

            }


            delete card.dataset.sellyWasNowActive;
            delete card.dataset.sellyLastLabel;

          }

          return;

        }


        var labelText =
          label.textContent.trim();


        /*
         * --------------------------------------------------------
         * DON'T REDO WORK IF NOTHING HAS CHANGED
         * --------------------------------------------------------
         */

        if (
          card.dataset.sellyWasNowActive === 'true' &&
          card.dataset.sellyLastLabel === labelText
        ) {

          return;

        }


        /*
         * --------------------------------------------------------
         * SAVE ORIGINAL STYLING ONCE
         * --------------------------------------------------------
         */

        if (
          card.dataset.sellyOriginalPriceStyle ===
          undefined
        ) {

          card.dataset.sellyOriginalPriceStyle =
            currentPrice.getAttribute('style') || '';

        }


        if (
          card.dataset.sellyOriginalOldStyle ===
          undefined
        ) {

          card.dataset.sellyOriginalOldStyle =
            oldPrice.getAttribute('style') || '';

        }


        if (
          card.dataset.sellyOriginalOldClass ===
          undefined
        ) {

          card.dataset.sellyOriginalOldClass =
            oldPrice.className;

        }


        if (
          card.dataset.sellyOriginalContainerStyle ===
          undefined
        ) {

          card.dataset.sellyOriginalContainerStyle =
            priceArea.getAttribute('style') || '';

        }


        /*
         * --------------------------------------------------------
         * DETERMINE NOW PRICE
         * --------------------------------------------------------
         */

        var discountedNumber = null;


        /*
         * CASE 1:
         *
         * Label contains:
         *
         * "NOW €399"
         *
         * --------------------------------------------------------
         */

        var fixedPriceMatch =
          labelText.match(
            /NOW\s*€?\s*([\d,.]+)/i
          );


        if (fixedPriceMatch) {

          discountedNumber =
            parseFloat(
              fixedPriceMatch[1]
                .replace(',', '.')
            );

        }


        /*
         * CASE 2:
         *
         * Label contains:
         *
         * "10% Off!"
         *
         * --------------------------------------------------------
         */

        if (discountedNumber === null) {

          var percentageMatch =
            labelText.match(
              /(\d+(?:\.\d+)?)\s*%\s*OFF/i
            );


          if (percentageMatch) {

            var percentage =
              parseFloat(
                percentageMatch[1]
              );


            if (!isNaN(percentage)) {

              discountedNumber =
                originalNumber *
                (1 - percentage / 100);

            }

          }

        }


        /*
         * If we don't recognise the Selly label,
         * leave the normal Shopify price alone.
         */

        if (
          discountedNumber === null ||
          isNaN(discountedNumber)
        ) {

          return;

        }


        /*
         * Round to two decimal places.
         */

        discountedNumber =
          Math.round(
            (discountedNumber + Number.EPSILON) * 100
          ) / 100;


        /*
         * --------------------------------------------------------
         * BUILD WAS / NOW DISPLAY
         * --------------------------------------------------------
         */

        oldPrice.innerHTML =
          '<del>' +
          formatPrice(originalNumber) +
          '</del>';


        currentPrice.textContent =
          formatPrice(discountedNumber);


        /*
         * --------------------------------------------------------
         * PRICE CONTAINER
         * --------------------------------------------------------
         */

        priceArea.style.setProperty(
          'display',
          'flex',
          'important'
        );

        priceArea.style.setProperty(
          'flex-direction',
          'row',
          'important'
        );

        priceArea.style.setProperty(
          'align-items',
          'baseline',
          'important'
        );

        priceArea.style.setProperty(
          'gap',
          '8px',
          'important'
        );

        priceArea.style.setProperty(
          'flex-wrap',
          'nowrap',
          'important'
        );


        /*
         * --------------------------------------------------------
         * WAS PRICE
         * --------------------------------------------------------
         */

        oldPrice.style.setProperty(
          'order',
          '1',
          'important'
        );

        oldPrice.style.setProperty(
          'display',
          'inline-block',
          'important'
        );

        oldPrice.style.setProperty(
          'margin',
          '0',
          'important'
        );


        /*
         * --------------------------------------------------------
         * NOW PRICE
         * --------------------------------------------------------
         */

        currentPrice.style.setProperty(
          'order',
          '2',
          'important'
        );

        currentPrice.style.setProperty(
          'display',
          'inline-block',
          'important'
        );

        currentPrice.style.setProperty(
          'color',
          '#d0021b',
          'important'
        );

        currentPrice.style.setProperty(
          'font-weight',
          '500',
          'important'
        );

        currentPrice.style.setProperty(
          'margin',
          '0',
          'important'
        );

        currentPrice.style.setProperty(
          'white-space',
          'nowrap',
          'important'
        );


        /*
         * --------------------------------------------------------
         * MARK AS PROCESSED
         * --------------------------------------------------------
         */

        card.dataset.sellyWasNowActive =
          'true';

        card.dataset.sellyLastLabel =
          labelText;

      });

  }



  /*
   * ============================================================
   * PRODUCT PAGE
   * ============================================================
   */

  function updateProductPagePrice() {

    var productInfo =
      document.querySelector(
        '.tt-product-single-info'
      );

    if (!productInfo) return;


    var priceArea =
      productInfo.querySelector(
        '.tt-price'
      );

    if (!priceArea) return;


    var currentPrice =
      priceArea.querySelector(
        '.new-price'
      );


    var oldPrice =
      priceArea.querySelector(
        '.old-price'
      );


    if (!currentPrice || !oldPrice) return;


    /*
     * --------------------------------------------------------
     * SELLY PRICES
     * --------------------------------------------------------
     */

    var sellyOriginal =
      productInfo.querySelector(
        '.tdf_price_original .tdf_money'
      );

    var sellySale =
      productInfo.querySelector(
        '.tdf_price_sales .tdf_money'
      );


    /*
     * --------------------------------------------------------
     * NO SELLY PROMOTION
     * --------------------------------------------------------
     */

    if (!sellyOriginal || !sellySale) {

      return;

    }


    var originalPrice =
      sellyOriginal.textContent.trim();

    var discountedPrice =
      sellySale.textContent.trim();


    /*
     * --------------------------------------------------------
     * SAVE ORIGINAL STYLING ONCE
     * --------------------------------------------------------
     */

    if (
      priceArea.dataset.sellyProductProcessed !==
      'true'
    ) {

      priceArea.dataset.sellyProductOriginalPrice =
        currentPrice.textContent;

      priceArea.dataset.sellyProductOriginalOldPrice =
        oldPrice.innerHTML;

      priceArea.dataset.sellyProductOriginalOldClass =
        oldPrice.className;

      priceArea.dataset.sellyProductOriginalPriceStyle =
        currentPrice.getAttribute('style') || '';

      priceArea.dataset.sellyProductOriginalOldStyle =
        oldPrice.getAttribute('style') || '';

      priceArea.dataset.sellyProductOriginalContainerStyle =
        priceArea.getAttribute('style') || '';

      priceArea.dataset.sellyProductProcessed =
        'true';

    }


    /*
     * --------------------------------------------------------
     * WAS PRICE
     * --------------------------------------------------------
     */

    oldPrice.innerHTML =
      '<del>' +
      originalPrice +
      '</del>';


    /*
     * --------------------------------------------------------
     * NOW PRICE
     * --------------------------------------------------------
     */

    currentPrice.textContent =
      discountedPrice;


    /*
     * --------------------------------------------------------
     * PRICE CONTAINER
     * --------------------------------------------------------
     */

    priceArea.style.setProperty(
      'display',
      'flex',
      'important'
    );

    priceArea.style.setProperty(
      'flex-direction',
      'row',
      'important'
    );

    priceArea.style.setProperty(
      'align-items',
      'baseline',
      'important'
    );

    priceArea.style.setProperty(
      'gap',
      '8px',
      'important'
    );

    priceArea.style.setProperty(
      'flex-wrap',
      'nowrap',
      'important'
    );


    /*
     * --------------------------------------------------------
     * WAS PRICE
     * --------------------------------------------------------
     */

    oldPrice.style.setProperty(
      'order',
      '1',
      'important'
    );

    oldPrice.style.setProperty(
      'display',
      'inline-block',
      'important'
    );

    oldPrice.style.setProperty(
      'margin',
      '0',
      'important'
    );


    /*
     * --------------------------------------------------------
     * NOW PRICE
     * --------------------------------------------------------
     */

    currentPrice.style.setProperty(
      'order',
      '2',
      'important'
    );

    currentPrice.style.setProperty(
      'display',
      'inline-block',
      'important'
    );

    currentPrice.style.setProperty(
      'color',
      '#d0021b',
      'important'
    );

    currentPrice.style.setProperty(
      'font-weight',
      '500',
      'important'
    );

    currentPrice.style.setProperty(
      'margin',
      '0',
      'important'
    );

    currentPrice.style.setProperty(
      'white-space',
      'nowrap',
      'important'
    );

  }



  /*
   * ============================================================
   * RUN EVERYTHING
   * ============================================================
   */

  function updateAllSellyPrices() {

    updateCollectionPrices();

    updateProductPagePrice();

  }


  /*
   * ============================================================
   * INITIAL RUNS
   * ============================================================
   */

  updateAllSellyPrices();


  /*
   * Selly can load after the page itself.
   *
   * These checks are deliberately limited rather than using
   * a constant calculation loop.
   */

  setTimeout(
    updateAllSellyPrices,
    500
  );

  setTimeout(
    updateAllSellyPrices,
    1000
  );

  setTimeout(
    updateAllSellyPrices,
    2000
  );

  setTimeout(
    updateAllSellyPrices,
    3000
  );


  /*
   * ============================================================
   * WATCH FOR SHOPIFY / SELLY DYNAMIC CONTENT
   * ============================================================
   *
   * This is mainly for collection filters and dynamically
   * replaced product cards.
   *
   * IMPORTANT:
   * The script does NOT continuously recalculate prices.
   * It only checks the DOM when something changes.
   */

  var observerTimeout = null;

  var observer =
    new MutationObserver(function () {

      clearTimeout(observerTimeout);

      observerTimeout =
        setTimeout(function () {

          updateAllSellyPrices();

        }, 300);

    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


})();